"use strict";

angular.module('app.directives.logButton', [])

    .directive("logButton", ["$filter", "__Device", "__DeviceLogSettings", "deviceLogSettingsModal","$stateParams",'f_Devices',
        function ($filter, __Device, __DeviceLogSettings, deviceLogSettingsModal,$stateParams,f_Devices) {
            return {
                restrict: 'A',
                template: "<div class='g-u-8-30  noTrans h46 gradient gradient-hover border-left obj-icon icon-datenlogging small-width icon medium pointer' ng-if='isVisible' ng-class='getClass()' ng-click='setLogSettingsForDevice()'></div>",
                scope: {
                    Datapoint: '=?datapoint',
                    // Device For Logging
                    Device: '=device',
                    visible: '=visible',
                    property: '@property',
                },
                link: function (scope) {
                    // set log object
                    var isDatapoint = scope.Datapoint !== undefined;
                    // set visibility
                    scope.isVisible = !isDatapoint || scope.Device.$UI.LoggingEnabledByUserlevel || scope.visible;

                    scope.getClass = function () {
                        // Decision: In fact the flag for DP and Device only supports Loggging Enabled and not spereately Local/Server
                        // We have to check for Logging EnabledByUserLevel wich ist processed by $dispatch('resolve-flags')
                        // <10 LVL only checks for StatisticEnabled, >10 Checking for LoggingEnabled (Which is also StatisticEnabled serverSide)
                        // Server handles automaticly if DeviceLoggingIsEnabled
                        if (isDatapoint
                            && scope.Device.$UI['LoggingEnabledByUserlevel']
                            && scope.Datapoint.$UI['LoggingEnabledByUserlevel']) {
                            return 'green';
                        }

                        if (!isDatapoint
                            && scope.Device.$UI['LoggingEnabledByUserlevel']) {
                            return 'green';
                        }

                        return '';
                    };

                    scope.setLogSettingsForDevice = function () {
                        var params = {
                            "Title": scope.Device.Name
                        };

                        var logDatapoint = {
                            "DeviceId": scope.Device.DeviceId
                        };


                        __DeviceLogSettings.$get(logDatapoint).$then(function (data) {
                            scope.Device.LogSettings = data;

                            // for datapoint configuration
                            var configurationDatapoint = null;
                            if (isDatapoint) {
                                var newLogSettings;
                                // Search for Datapoints in LogSettings
                                var point = ( $filter('filter')(scope.Device.LogSettings.DatapointsToLog, {DatapointValue: {DatapointConfigId: scope.Datapoint.DatapointConfig.DatapointConfigId}}) );
                                if (point && point.length > 0) {
                                    // Found some points
                                    configurationDatapoint = point[0];
                                    if (point.length > 1) {
                                        var oneLeft;
                                        for (var i = scope.Device.LogSettings.DatapointsToLog.length; i >= 0; i--) {
                                            if (scope.Device.LogSettings.DatapointsToLog[i].DatapointValue.DatapointConfigId === scope.Datapoint.DatapointConfig.DatapointConfigId) {
                                                if (oneLeft) {
                                                    scope.Device.LogSettings.DatapointsToLog.splice(i, 1);
                                                } else {
                                                    oneLeft = true;
                                                }
                                            }
                                        }

                                    }
                                } else {
                                    configurationDatapoint = {
                                        DatapointValue: scope.Datapoint.DatapointValue
                                    };
                                    newLogSettings = true;
                                }

                                params = {

                                    "Title": scope.Device.Name + ' ' + scope.Datapoint.DatapointConfig.DisplayName,
                                    "Device": scope.Device
                                };
                            }

                            deviceLogSettingsModal(scope.Device.LogSettings, configurationDatapoint, params).then(function (modal) {
                                modal.close.then(function (data) {
                                    if (data) {
                                        // Save Log Settings
                                            if (isDatapoint) {
                                            var DatapointLogSettings = {
                                                LoggingServerEnabled: data.LoggingServerEnabled,
                                                LoggingLocalEnabled: data.LoggingLocalEnabled,
                                                StatisticLoggingEnabled: data.StatisticLoggingEnabled,
                                                ReadInterval: data.ReadInterval,
                                                Hysteresis: data.Hysteresis,
                                                DatapointValue: configurationDatapoint.DatapointValue
                                            };
                                            //configurationDatapointconfigurationDatapoint.DatapointValue;
                                            if (newLogSettings) {
                                                scope.Device.LogSettings.DatapointsToLog.push(DatapointLogSettings);
                                            } else {
                                                // Find Datapoint
                                                var point = ( $filter('filter')(scope.Device.LogSettings.DatapointsToLog, {DatapointValue: {DatapointConfigId: scope.Datapoint.DatapointConfig.DatapointConfigId}}) );
                                                var i = scope.Device.LogSettings.DatapointsToLog.indexOf(point[0]);
                                                scope.Device.LogSettings.DatapointsToLog[i] = DatapointLogSettings;
                                            }
                                            scope.Device.LogSettings.$save().$then(function () {

                                                scope.Datapoint.DatapointValue.$read().$then(function (data) {
                                                    console.log('Flags', scope.Datapoint);

                                                    scope.Datapoint.DatapointValue.Flags = data.Flags;
                                                    scope.Datapoint.$dispatch('resolve-flags');
                                                    scope.Datapoint.setReadFlags();
                                                    scope.Device.$dispatch('resolve-flags');
                                                    f_Devices.addOrUpdateDevice( scope.Device );
                                                });
                                            });
                                        } else {
                                            var DeviceLogSettings = {
                                                LoggingServerEnabled: data.LoggingServerEnabled,
                                                LoggingLocalEnabled: data.LoggingLocalEnabled,
                                                StatisticEnabled: data.StatisticEnabled,
                                                ForceLoggingInterval: data.ForceLoggingInterval
                                            };
                                            // alert(data.StatisticEnabled);

                                            scope.Device.LogSettings = angular.extend(scope.Device.LogSettings, DeviceLogSettings);
                                            scope.Device.LogSettings.$save().$then(function () {

                                                __Device.$byId(scope.Device.DeviceId).$then(function (data) {

                                                    scope.Device.Flags = data.Flags;
                                                    scope.Device.$dispatch('resolve-flags');
                                                    f_Devices.addOrUpdateDevice( scope.Device );

                                                    scope.$emit('HeadDevice_Flags',{device:scope.Device});
                                                    scope.$emit('childentries-refresh-values');
                                                });
                                            });
                                        }
                                    }
                                });
                            });
                        });

                    };

                    scope.setLogSettings = function (Device, Datapoint) {
                        var a = {
                            "DeviceId": Device.DeviceId
                        };

                        Device.LogSettings = __DeviceLogSettings.$get(a).$then(function (data) {

                                Device.LogSettings = data;
                            Device.$dispatch('resolve-flags');
                                var dp;
                                //Device.LogSettings = data;

                                // Search for Datapoints in Logsettings
                                var point = ( $filter('filter')(Device.LogSettings.DatapointsToLog, {DatapointValue: {DatapointConfigId: Datapoint.DatapointConfig.DatapointConfigId}}) );
                                if (point && point.length > 0) {
                                    // Found some points
                                    dp = point[0];
                                    if (point.length > 1) {
                                        var oneLeft;
                                        for (var i = Device.LogSettings.DatapointsToLog.length; i >= 0; i--) {
                                            if (Device.LogSettings.DatapointsToLog[i].DatapointValue.DatapointConfigId === Datapoint.DatapointConfig.DatapointConfigId) {
                                                if (oneLeft) {
                                                    Device.LogSettings.DatapointsToLog.splice(i, 1);
                                                } else {
                                                    oneLeft = true;
                                                }
                                            }
                                        }

                                    }

                                } else {
                                    dp = {
                                        DatapointValue: Datapoint.DatapointValue
                                    };
                                    var newLogSettings = true;
                                }
                                var params = {

                                    "Title": Device.Name + ' ' + Datapoint.DatapointConfig.DisplayName,
                                    "Device": Device
                                };
                                deviceLogSettingsModal(Device.LogSettings, dp, params).then(function (modal) {
                                    modal.close.then(function (data) {
                                        if (data) {
                                            // Save Log Settings
                                            var LogSettings = {
                                                LoggingServerEnabled: data.LoggingServerEnabled,
                                                LoggingLocalEnabled: data.LoggingLocalEnabled,
                                                StatisticLoggingEnabled: data.StatisticLoggingEnabled,
                                                ReadInterval: data.ReadInterval,
                                                Hysteresis: data.Hysteresis,

                                                DatapointValue: dp.DatapointValue

                                            };
                                            //data
                                            if (newLogSettings) {
                                                Device.LogSettings.DatapointsToLog.push(LogSettings);
                                            } else {
                                                // Find Datapoint
                                                var point = ( $filter('filter')(Device.LogSettings.DatapointsToLog, {DatapointValue: {DatapointConfigId: Datapoint.DatapointConfig.DatapointConfigId}}) );
                                                var i = Device.LogSettings.DatapointsToLog.indexOf(point[0]);
                                                Device.LogSettings.DatapointsToLog[i] = LogSettings;
                                            }
                                            Device.LogSettings.$save().$finally(function () {

                                                Datapoint.DatapointValue.$read().$finally(function (data) {

                                                    Datapoint.DatapointValue.Flags = data.Flags;
                                                    Datapoint.$dispatch('resolve-flags');
                                                    Datapoint.setReadFlags();
                                                });
                                            });
                                        }
                                    });
                                });

                        });

                    };
                }
            };
        }
    ]);
